/**
 * bak-size-guide.js
 *
 * Opens a modal with the Shopify Page content referenced by
 * product.metafields.custom.size_chart_1. Links in the variant
 * picker carry data-bak-size-guide-handle="<page-handle>" and
 * point to /pages/<handle> as a graceful fallback if JS fails.
 */
(function () {
  'use strict';

  const cache = new Map();

  function getDialog() {
    return document.getElementById('bak-size-guide-dialog');
  }

  function setContent(html) {
    const dialog = getDialog();
    if (!dialog) return;
    const box = dialog.querySelector('[data-bak-size-guide-content]');
    if (box) box.innerHTML = html;
  }

  function showLoading() {
    setContent('<div class="bak-size-guide-dialog__loading">Wird geladen…</div>');
  }

  function showError() {
    setContent('<div class="bak-size-guide-dialog__loading">Inhalt konnte nicht geladen werden.</div>');
  }

  async function fetchPageContent(url) {
    if (cache.has(url)) return cache.get(url);
    const res = await fetch(url, { credentials: 'same-origin' });
    if (!res.ok) throw new Error('Fetch failed: ' + res.status);
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');

    // Prefer the page's main content block. Fall back through likely containers.
    const candidates = [
      'main .rte',
      'main article',
      'main .page',
      'main .page-content',
      '.shopify-section-main-page',
      'main',
    ];
    let node = null;
    for (const sel of candidates) {
      node = doc.querySelector(sel);
      if (node && node.textContent.trim().length > 20) break;
    }
    const extracted = node ? node.innerHTML : '<p>Kein Inhalt gefunden.</p>';
    cache.set(url, extracted);
    return extracted;
  }

  async function openFromLink(link) {
    const dialog = getDialog();
    if (!dialog) return;
    const url = link.getAttribute('href');
    if (!url) return;

    showLoading();
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');

    try {
      const content = await fetchPageContent(url);
      setContent(content);
    } catch (e) {
      console.warn('[bak-size-guide] failed', e);
      showError();
    }
  }

  function closeDialog() {
    const dialog = getDialog();
    if (!dialog) return;
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
  }

  function init() {
    document.addEventListener('click', (e) => {
      const target = e.target;
      if (!(target instanceof Element)) return;

      const link = target.closest('.bak-size-guide-link');
      if (link) {
        e.preventDefault();
        openFromLink(link);
        return;
      }

      const close = target.closest('[data-bak-size-guide-close]');
      if (close) {
        e.preventDefault();
        closeDialog();
        return;
      }

      // Click on backdrop (outside dialog content box) closes
      const dialog = getDialog();
      if (dialog && dialog.hasAttribute('open') && target === dialog) {
        closeDialog();
      }
    });

    // Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        const dialog = getDialog();
        if (dialog && dialog.hasAttribute('open')) closeDialog();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
